import { useQuery } from "@tanstack/react-query";
import { getRaceByTrack } from "../api";

const useRaceByTrack = (trackCode: string, raceNumber: number) => {
  const { data, isError } = useQuery({
    queryKey: ["horse races by track", trackCode, raceNumber],
    queryFn: () => getRaceByTrack({ trackCode, raceNumber }),
  });

  const race = data?.HR_Track?.races?.[0];
  const trackName = data?.HR_Track?.name;
  const trackDataSource = data?.HR_Track?.trackDataSource;

  return {
    race,
    trackName,
    trackDataSource,
    isError,
  };
};

export default useRaceByTrack;
